import apiService from "../service";

export function fetchDashboard(drive) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/dashboard", {
        params: {
            "drive": drive
        },
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchAllocation(drive) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/allocation", {
        params: {
            "drive": drive
        },
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchEmpAllocation() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/pref/allocation", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchAllocationStatus(drive) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/allocation-status", {
        params: {
            "drive": drive
        },
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchLaunchStatus(drive) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/launch-status", {
        params: {
            "drive": drive
        },
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function allocateEmployees() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/admin/processAllocation", {}, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function launchAllocation(otp) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/admin/launchAllocation?otp=" + otp, {}, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function launchAllocationDrive(otp, drive) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/admin/launch-allocation-drive?otp=" + otp + "&drive=" + drive, {}, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function fetchAllocatedEmployees() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/allocated-employees", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchAllocatedEmployee(regNo) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.get(`/admin/allocated-employee?regNo=${regNo}`, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
        }
    });
}
export function fetchEmployeeTimeline(regNo) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.get(`/admin/employee-profile?regNo=${regNo}`, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
        }
    });
}
export function fetchEmployeeAllocationLetter(regNo) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.get(`/admin/posting-order?regNo=${regNo}`, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
        },
                    responseType: 'arraybuffer',
    });
}
export function fetchEligibleEmployees() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/eligible-employees", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchAllCandidates() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/all-employees", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchEmployeesMerit(drive) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get(`/admin/employees-merit?drive=${drive}`, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchDriveVacancy() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/current-vacancies", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function decrementVacancy(department, district, post) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    const formData = new FormData()
    formData.append("department", department)
    formData.append("district", district)
    formData.append("post", post)
    return apiService.post("/admin/remove-vacancy", formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function fetchJoinedEmployees() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/joined-employees", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function employeeJoining(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post("/admin/employee-joining",
        formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    }
    );
}
export function employeeEligible(formData, isBulk = false) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    const apiEndPoint = isBulk == false ? "/admin/mark-eligible" : "/admin/upload-eligibility";
    return apiService.post(apiEndPoint,
        formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    }
    );
}
export function vacancyUpload(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post("/admin/upload-vacancy",
        formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    }
    );
}
export function consentUpload(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post("/admin/upload-consent",
        formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    }
    );
}

export function consentResponse(response) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post("/reg/saveConsent",
        response, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    }
    );
}
export function downloadConsent(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.get(`/api/reports/download/consent/${formData}`, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        },
        responseType: 'blob'
    }
    );
}
export function createConsent(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post("/admin/create-consent",
        formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    }
    );
}
export function fetchConsentDrive(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.get("/admin/get-consent", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    }
    );
}
export function fetchReportsTypesAction() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.get("/api/reports/types", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    }
    );
}
export function fetchReportsHistoryAction(page = 0, size = 10, status = '') {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    // Build query parameters
    let queryParams = `?page=${page}&size=${size}`;
    if (status) {
        queryParams += `&status=${status}`;
    }

    return apiService.get(`/api/reports/all${queryParams}`, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    }
    );
}
export function submitReportsTypeAction(reportCode) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post("/api/reports/submit",
        reportCode, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
        }
    }
    );
}
export function cancelReportAction(reportCode) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post(`/api/reports/cancel/${reportCode}`, {}, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    }
    );
}
export function downloadReportAction(reportCode) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.get(`/api/reports/download/${reportCode}`, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        },
        responseType: 'blob'
    }
    );
}
export function meritUpload(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);

    return apiService.post("/admin/upload-merit",
        formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    }
    );
}

export function fetchDrive() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/drive-config", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchAllEmployees() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/drive-config", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function createDrive(data) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/admin/drive-config", data, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}
export function fetchRevokedPostingEmployees() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/revoked-posting-employees", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function fetchPreviousPostingDetails(regNo) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/previous-posting-details", {
        params: {
            "regNo": regNo
        },
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function grantPreviousPosting(formData) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/admin/grant-previous-posting", formData, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    });
}
export function revokePosting(data, isBulk = false) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    const apiEndPoint = isBulk == false ? "/admin/revoke-posting" : "/admin/upload-revoke-posting";
    return apiService.post(apiEndPoint, data, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    });
}
export function downloadVacancyTemplate() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/admin/vacancy-template", { headers: { "Authorization": "Bearer " + tokenDetails.token }, responseType: "blob" });
    } catch (error) {
    }
}
export function downloadMeritTemplate() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/admin/merit-template", { headers: { "Authorization": "Bearer " + tokenDetails.token }, responseType: "blob" });
    } catch (error) {
    }
}

export function getCurrentDriveConfig() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/admin/drive-config/current", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function newDriveConfig(driveConfigRequest) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/admin/drive-config", driveConfigRequest, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function fetchManualReAllocationOptions() {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.get("/api/hrd/vacancy-options", {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function checkVacancy(payload) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/api/hrd/check-vacancy", payload, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token
        }
    });
}

export function submitReAllocation(payload) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/api/hrd/manual-reallocation", payload, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    });
}

export function submitBulkReAllocation(payload) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = JSON.parse(tokenDetailsString);
    return apiService.post("/api/hrd/manual-reallocation/bulk", payload, {
        headers: {
            "Authorization": "Bearer " + tokenDetails.token,
            "content-type": "multipart/form-data"
        }
    });
}
